<template>
  <div>
    <v-card class="quoteSideInfo">
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{motorIcon}}</v-icon>
          Motor
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn flat slot="activator" @click="doSave()" :loading="quotation.saving">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
          <span>Save Quotation/Proposal</span>
        </v-tooltip>
        <v-tooltip top>
          <v-menu bottom left slot="activator">
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="promptNTU = true">
                <v-list-tile-title>Not Taken Up</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="promptVoid = true">
                <v-list-tile-title>Void</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <span>More Options</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <v-subheader class="queryLabel">Quotation No.</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span class="title">{{commonForm.proposalNo}}</span>
            </v-flex>
            <template v-if="renderPremium">
              <v-flex xs4>
                <v-subheader class="queryLabel">Premium Payable</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{currPrefix}}{{formatDisplayNumber(commonInfo.premium.premiumPayable)}}</span>
              </v-flex>
            </template>
            <v-flex xs4>
              <v-subheader class="queryLabel">Current Status</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span>{{currentStatusLabel}}</span>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">Intermediary</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span>{{intermediary}}</span>
            </v-flex>
            <template v-if="quotePermitStatus.permitStatus !== 'A'">
              <v-flex xs4>
                <v-subheader class="queryLabel">Permit Status</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span v-if="quotePermitStatus.permitStatus === 'R'" class="warning--text">{{quotePermitStatusLabel}}</span>
                <span v-else-if="quotePermitStatus.permitStatus === 'D'" class="error--text">{{quotePermitStatusLabel}}</span>
                <span v-else>{{quotePermitStatusLabel}}</span>
              </v-flex>
              <v-flex xs4>
              </v-flex>
              <v-flex xs8>
                <div v-if="quotePermitStatus.permitStatus === 'R'">
                  <ul class="permitStatus">
                    <li v-for="status in quotePermitStatus.referredList" :key="status">{{status}}</li>
                  </ul>
                </div>
                <div v-else-if="quotePermitStatus.permitStatus === 'D'">
                  <ul class="permitStatus">
                    <li v-for="status in quotePermitStatus.declineList" :key="status">{{status}}</li>
                  </ul>
                </div>
              </v-flex>
            </template>
            <template v-if="commonForm.product">
              <v-flex xs4>
                <v-subheader class="queryLabel">Product</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{product}}</span>
              </v-flex>
            </template>
            <template v-if="motorForm.busCls">
              <v-flex xs4>
                <v-subheader class="queryLabel">Business Class</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{busCls}}</span>
              </v-flex>
            </template>
            <template v-if="motorForm.tariff">
              <v-flex xs4>
                <v-subheader class="queryLabel">Tariff</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{tariff}}</span>
              </v-flex>
            </template>
            <template v-if="motorForm.cover">
              <v-flex xs4>
                <v-subheader class="queryLabel">Type of Cover</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{cover}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.startDate">
              <v-flex xs4>
                <v-subheader class="queryLabel">Acceptance Date</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDisplayDateTime2(commonForm.acceptDate)}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.startDate">
              <v-flex xs4>
                <v-subheader class="queryLabel">Start Date</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDate(commonForm.startDate)}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.endDate">
              <v-flex xs4>
                <v-subheader class="queryLabel">End Date</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDate(commonForm.endDate)}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.campaign">
              <v-flex xs4>
                <v-subheader class="queryLabel">Campaign</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{campaign}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.promotion">
              <v-flex xs4>
                <v-subheader class="queryLabel">Promotion</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{promotion}}</span>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <confirm v-model="promptNTU" @ok="doNTU">
      Confirm that you want to change the status of this Quotation to
      <b>Not Taken Up</b>?
    </confirm>
    <confirm v-model="promptVoid" @ok="doVoid">
      Confirm that you want to change the status of this Quotation to
      <b>Void</b>?
    </confirm>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { extractLabel } from '@/utils/extract'
import { formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { mtrPermitStatus } from '@/const/underwriting/motor'
import { quoteStatus, appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      promptNTU: false,
      promptVoid: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    currentStatusLabel() {
      if (quoteStatus[this.commonInfo.statusCode]) {
        return quoteStatus[this.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    renderPremium() {
      if (this.commonInfo.premium.premiumPayable && this.commonInfo.premium.premiumPayable > 0) {
        if (this.commonInfo.statusCode === 'NQ' || this.commonInfo.statusCode === 'QPA') {
          if (this.quotePermitStatus.permitStatus === 'A') {
            return true
          } else if (this.quotePermitStatus.permitStatus === 'R') {
            // Only allow if user has permit acccess
            if (this.checkAccess(['motorQuoteRef', 'motorQuoteSTP'])) {
              return true
            }
          }
        } else {
          return true
        }
      }
      return false
    },
    motorForm() {
      return this.quotation.motorForm
    },
    commonForm() {
      return this.quotation.commonForm
    },
    commonInfo() {
      return this.quotation.commonInfo
    },
    motorParam() {
      return this.quotation.motorParam
    },
    intermediary() {
      return extractLabel(this.$store.state.agency.quotationSettings.intermediaries, this.quotation.commonForm.intermediary)
    },
    product() {
      return extractLabel(this.motorParam.product, this.commonForm.product)
    },
    busCls() {
      return extractLabel(this.motorParam.busCls, this.motorForm.busCls)
    },
    tariff() {
      return extractLabel(this.motorParam.tariff, this.motorForm.tariff)
    },
    cover() {
      return extractLabel(this.motorParam.cover, this.motorForm.cover)
    },
    ncdRate() {
      return extractLabel(this.motorParam.ncdRate, this.motorForm.ncdRate)
    },
    quotePermitStatus() {
      return this.$store.getters.mtrQuotePermitStatus
    },
    quotePermitStatusLabel() {
      return mtrPermitStatus[this.quotePermitStatus.permitStatus]
    },
    campaign() {
      return extractLabel(this.motorParam.campaign, this.commonForm.campaign)
    },
    promotion() {
      return extractLabel(this.motorParam.promotion, this.commonForm.promotion)
    },
    motorIcon() {
      return appIcon.MOTOR
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime2(date) {
      return formatDisplayDateTime2(date)
    },
    doSave() {
      // Emit saving event on global event bus
      // Each quote page should listen to this and do partial Submit and save
      this.$root.$emit('saveQuote')
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    doNTU() {
      this.$root.$emit('ntu')
    },
    doVoid() {
      this.$root.$emit('void')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
@media (min-width: 1264px) {
  .quoteSideInfo {
    // Module specific override
    min-height: 425px;
  }
}

.permitStatus {
  padding-left: 20px;
}
</style>
